import {AssetAudioMap} from 'types'
import {getCDNBaseUrl} from '../../../utils/environment/EnvirontmentHelper'

export const AUDIO_ASSET = <T extends keyof AssetAudioMap>(
  type: T,
  file: AssetAudioMap[T],
) => `${getCDNBaseUrl()}/${type}/${file}`
